import React from 'react';

import { Layout } from '../Layout/Layout';
import { LayoutItem } from '../Layout/LayoutItem';
import { Flashy } from '../../element/Flashy/Flashy';
import { ParagraphHeader } from '../../content/ParagraphHeader/ParagraphHeader';
import NoResults from '../../../public/static/svg/no-results-binoculars.svg';

import type { DataGridNoResultsProps } from './data-grid.types';

export const DataGridNoResults = ({
  noRowsMessageFunc,
}: DataGridNoResultsProps) => (
  <Layout
    name="DATA_GRID_NO_RESULTS"
    position="center middle"
    horizontalGutter="8px"
  >
    <LayoutItem>
      <NoResults width={75} height={75} />
    </LayoutItem>
    <LayoutItem>
      <Flashy bold>
        <ParagraphHeader name="DATA_GRID_NO_RESULTS_MESSAGE">
          {noRowsMessageFunc()}
        </ParagraphHeader>
      </Flashy>
    </LayoutItem>
  </Layout>
);
